<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: ['value'],
  setup() {

  },
})
</script>

<template>
  <a-radio-group
    :value="value"
    class="font-weight-bold"
    :disabled="$route.query.edit || $route.query.master_product ? true : false"
    @input="(value) => {
      $emit('input', value)
    }"
  >
    <a-radio value="SOFT">
      {{ $t('product.soft_bundling') }}
    </a-radio>
    <a-radio value="HARD">
      {{ $t('product.hard_bundling') }}
    </a-radio>
  </a-radio-group>
</template>
